module.exports = __webpack_public_path__ + "static/media/Netfabb.b17207a1.png";